//Quick View


$(document).ready(function() {


  $(document).click(function() {
    var $target = $(event.target);
    if (!$target.is(".add__cart span") && !$target.is(".add__cart") && !$target.is(".addcart .modal-content")) {
      $('.addcart').removeClass('in show');
    }
    if (!$target.is(".quickview") && !$target.is(".quickview img") && !$target.is(".quickviewModal .modal-content") && !$target.parents().is(".quickviewModal")) {
      $('.quickviewModal').removeClass('in show');
    }
  });
  $(document).on('click', '.add__cart', function() {
    let formQuickview = new URLSearchParams($('.quickviewModal form').serialize());
    let quickViewQuantity = formQuickview.get('quantity');
    console.log(quickViewQuantity);
    var product_handle = $(this).data('handle');
    var product_id = $(this).data('id');
    var number_product = quickViewQuantity && quickViewQuantity > 1 ? quickViewQuantity : $(this).parents('.addcart_').find('.add_to--cart').attr('data-value');
    $('.addcart').attr('id', 'addcart_' + product_id);
    let formData = {
      'items': [{
        'id': $(this).parents('.addcart_').find('.product-single__variants :selected').val(),
        'quantity': number_product
      }]
    };
    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        if (response.status == 422) {
          alert('The number of products in stock is not enough.');
        } else {
          $('.addcart').addClass('in show');
        }
        return response.json();
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    setTimeout(function() {
      $.getJSON('/cart.json', function(cart) {
        var current_cart = cart.item_count;
        if (current_cart <= 1) {
          $('.addcart .subtitle').text('Your cart has ' + current_cart + ' item');
          $('.cart_count').html(current_cart);
        } else {
          $('.addcart .subtitle').text('Your cart has ' + current_cart + ' items');
          $('.cart_count').html(current_cart);
        }
      });
    }, 500);
    jQuery.getJSON('/products/' + product_handle + '.js', function(product) {
      var title = product.title;
      var price = 0;
      var original_price = 0;
      var images = product.images;
      var variants = product.variants;
      var options = product.options;

      var url = '/products/' + product_handle;
      $('.addcart .name_').text(title);
      $('.addcart .product_wrap a').attr('href', url);
      var imageCount = $(images).length;
      $(images).each(function(i, image) {
        if (i == imageCount - 1) {
          var image_embed = '<img src="' + image + '" alt="' + title + '">';
          $('.addcart .product_wrap .img').html(image_embed);
        } else {
          image_embed = '<img src="' + image + '" alt="' + title + '">';
          $('.addcart .product_wrap .img').html(image_embed);

        }

      });
      $(product.variants).each(function(i, v) {

        if (v.inventory_quantity == 0) {

          $('.qv-add-button').prop('disabled', true).val('Sold Out');

          $('.qv-add-to-cart').hide();

          $('.qv-product-price').text('Sold Out').show();

          return true

        } else {

          price = parseFloat(v.price / 100).toFixed(2);

          original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
          if (number_product >= 2) {
            $('.price').text('$' + price + ' x ' + number_product);
          } else {
            $('.price').text('$' + price);
          }

          if (original_price > 0) {

            $('.qv-product-original-price').text('$' + original_price).show();

          } else {

            $('.qv-product-original-price').hide();

          }

          return false

        }

      });

    });
    
  });
  $(document).on('click', '.quickview', function() {
    $('.quickviewModal').addClass('in show');
  });
  $(document).on('click', '.quickviewModal .btn-close', function() {
    $('.quickviewModal').removeClass('in show');
    $('.quickviewModal form')[0].reset();
  });
  $(document).on('click', '.quickviewModal .form_product .btn', function(e) {
    let id = $(this).attr('data-id');
    e.preventDefault();
    $('.quickviewModal').removeClass('in show');
    $(`.add_to--cart.add__cart[data-id="${id}"]`).click();
    $('.quickviewModal form')[0].reset();
  });
  $(document).on('click', '.quantity-input', function() {
    $(this).select();
  });
});


$(window).resize(function() {

  if ($('#quick-view').is(':visible')) {

    $('.qv-product-images').slick('setPosition');

  }

});